import React, { useRef, useCallback, useEffect } from "react";
import { useSpring, animated } from "react-spring";
import {
  Background,
  ModalContent,
  CloseModalButton,
  Button,
} from "../../ModalRegisterStyle";
import styled from "styled-components";

const QrCodeContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 20px;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const QrCodeSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const QrCodeImage = styled.img`
  width: 200px;
  height: 200px;
  border: 1px solid #ddd;
  border-radius: 8px;
`;

const InfoText = styled.p`
  font-size: 1rem;
  color: #666;
  text-align: center;
`;

export default function ModalQrCodeViewer({ showModal, setShowModal, qrData }) {
  const modalRef = useRef();

  const animation = useSpring({
    config: {
      duration: 150,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`,
  });

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) {
        setShowModal(false);
      }
    },
    [setShowModal, showModal]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  const handleDownload = (base64, type) => {
    const link = document.createElement("a");
    link.href = base64;
    link.download = `QR_${type}_${qrData.matricula}_${qrData.nome.replace(
      / /g,
      "_"
    )}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {showModal && qrData ? (
        <Background
          ref={modalRef}
          onClick={(e) => {
            if (modalRef.current === e.target) {
              setShowModal(false);
            }
          }}
        >
          <animated.div style={animation}>
            <ModalContent>
              <h3>QR Codes - {qrData.nome}</h3>
              <p>Matrícula: {qrData.matricula}</p>
              <hr />

              <QrCodeContainer>
                {qrData.qr_code_cesta_img ? (
                  <QrCodeSection>
                    <h4>Cesta de Natal</h4>
                    <QrCodeImage
                      src={qrData.qr_code_cesta_img}
                      alt="QR Code Cesta"
                    />
                    <Button
                      onClick={() =>
                        handleDownload(qrData.qr_code_cesta_img, "Cesta")
                      }
                    >
                      Download
                    </Button>
                  </QrCodeSection>
                ) : (
                  <InfoText>Sem direito à cesta.</InfoText>
                )}

                {qrData.qr_code_brinquedo_img ? (
                  <QrCodeSection>
                    <h4>Brinquedo</h4>
                    <QrCodeImage
                      src={qrData.qr_code_brinquedo_img}
                      alt="QR Code Brinquedo"
                    />
                    <Button
                      onClick={() =>
                        handleDownload(qrData.qr_code_brinquedo_img, "Brinquedo")
                      }
                    >
                      Download
                    </Button>
                  </QrCodeSection>
                ) : (
                  <InfoText>Sem direito a brinquedo.</InfoText>
                )}
              </QrCodeContainer>

              <CloseModalButton onClick={() => setShowModal(false)} />
            </ModalContent>
          </animated.div>
        </Background>
      ) : null}
    </>
  );
}
